import Vue from 'vue';
import './registerServiceWorker';
import router from './router';

import { VueDiContainer } from 'vue-di-container';

// Plugins
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import coreUI from '@moj/najiz-mui';
import najizToaster, { IToasterAPI } from '@moj/najiz-toastify';
// Components
import App from './views/App/app';
// styles
import '../public/styles/main.scss';
import LoaderService from './services/loader';
import initializeApplication from './plugins/application-initialization';
import FeatureToggleService from '@/services/featureToggle';
// ! Core UI Components
import ServiceCard from './components/ServiceCard/serviceCard';
import trackingController, { TrackerElement } from '@moj/najiz-tracking';
import HttpService from '@/services/httpService';
import http from '@moj/najiz-http';
import TelemetryService from './services/TelemetryService';

Vue.component('TrackerElement', TrackerElement);
Vue.component('ServiceCard', ServiceCard);

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.use(VueDiContainer);
Vue.use(coreUI);
Vue.use(najizToaster);

declare module 'vue/types/vue' {
  interface Vue {
    $appInsights: any;
    $nToaster: IToasterAPI;
  }
}

declare global {
  interface Window {
    $config: any;
    $disableNewRequestsPeriod: any;
    showLoader(): void;
    hideLoader(): void;
    ApplePaySession: any,
  }
}

initializeApplication().then(() => {
  Vue.use(trackingController, {
    router,
    http,
    appInfo: window.$config.ApplicationInsights,
  });
  new Vue({
    i18n,
    router,
    vuetify,
    diProvide: [
      HttpService,
      LoaderService,
      TelemetryService,
      FeatureToggleService,
    ],
    render: (h) => h(App),
  }).$mount('#app');
});
